import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
import imageWithMetaDataSchema from '@utils/validate/blocksSchemes/imageWithMetadataSchema';
const categoryGallerySchema = Joi.object({
  type: Joi.string().valid('categoryGallery').required(),
  code: Joi.string().allow('', null).required(),
  title: Joi.string().allow('', null).required(),
  description: Joi.string().allow('', null).required(),
  images: Joi.array().items(Joi.object({
    itemId: Joi.string().required(),
    image: Joi.alternatives().try(Joi.string(), Joi.object(imageWithMetaDataSchema)).allow(null),
    imageWithBlur: Joi.object({
      image: mediaUrlSchema,
      blur: mediaUrlSchema
    }).allow('', null),
    orientation: Joi.string().required(),
    products: Joi.array().items(Joi.object().unknown(true)),
    tags: Joi.alternatives().try(Joi.array().items(Joi.string()).optional(), Joi.object().pattern(Joi.string(), Joi.array().items(Joi.string())).optional())
  }).unknown(true)),
  availableTags: Joi.object().pattern(Joi.string(), Joi.object({
    code: Joi.string().required(),
    name: Joi.string().required(),
    values: Joi.array().items(Joi.object({
      code: Joi.string().required(),
      name: Joi.string().required()
    })).required()
  })).optional(),
  blockAppearance: {
    ...blockAppearanceSchema
  }
}).unknown(true);
export default categoryGallerySchema;